const MODULE_NAME = 'fulcrum/container/Project/Header/'

const COLLAPSE_HEADER = MODULE_NAME + 'COLLAPSE_HEADER'
const EXPAND_HEADER = MODULE_NAME + 'EXPAND_HEADER'
const TOGGLE_HEADER = MODULE_NAME + 'TOGGLE_HEADER'

const SET_COLLAPSING = MODULE_NAME + 'SET_COLLAPSING'

const SET_STICKY = MODULE_NAME + 'SET_STICKY'

const TOGGLE_DESCRIPTION_COLLAPSE = MODULE_NAME + 'TOGGLE_DESCRIPTION_COLLAPSE'
const TOGGLE_DESCRIPTION_EDIT = MODULE_NAME + 'TOGGLE_DESCRIPTION_EDIT'
const OPEN_DESCRIPTION_EDIT = MODULE_NAME + 'OPEN_DESCRIPTION_EDIT'
const CLOSE_DESCRIPTION_EDIT = MODULE_NAME + 'CLOSE_DESCRIPTION_EDIT'
const SET_DESCRIPTION_OBJ = MODULE_NAME + 'SET_DESCRIPTION_OBJ'
const SET_DESCRIPTION = MODULE_NAME + 'SET_DESCRIPTION'
const TOGGLE_RISK = MODULE_NAME + 'TOGGLE_RISK'
const SAVE_DESCRIPTION = MODULE_NAME + 'SAVE_DESCRIPTION'
const SAVE_DESCRIPTION_ERROR = MODULE_NAME + 'SAVE_DESCRIPTION_ERROR'

const TOGGLE_MORE_INFO = MODULE_NAME + 'TOGGLE_MORE_INFO'
const TOGGLE_RELATED_PROJECTS = MODULE_NAME + 'TOGGLE_RELATED_PROJECTS'

const TOGGLE_RELATED_PROJECTS_SHOW_ALL = MODULE_NAME + 'TOGGLE_RELATED_PROJECTS_SHOW_ALL'

export {
  MODULE_NAME,
  COLLAPSE_HEADER,
  EXPAND_HEADER,
  TOGGLE_HEADER,
  SET_COLLAPSING,
  SET_STICKY,
  TOGGLE_DESCRIPTION_COLLAPSE,
  TOGGLE_DESCRIPTION_EDIT,
  OPEN_DESCRIPTION_EDIT,
  CLOSE_DESCRIPTION_EDIT,
  SET_DESCRIPTION_OBJ,
  SET_DESCRIPTION,
  TOGGLE_RISK,
  SAVE_DESCRIPTION,
  SAVE_DESCRIPTION_ERROR,
  TOGGLE_MORE_INFO,
  TOGGLE_RELATED_PROJECTS,
  TOGGLE_RELATED_PROJECTS_SHOW_ALL,
}
